import OngoingBooksSubtitle from './OngoingBooksSubtitle'

export default OngoingBooksSubtitle
